import { Navigate } from "react-router-dom";
import type { ReactNode } from "react";
import { useAppSelector } from "@/store/hooks";

export function useHasModule(key?: string): boolean {
  const modules = useAppSelector((s) => s.auth.user?.modules);
  return !key || !modules || modules.includes(key);
}

export function RequireModule({ module, children }: { module: string; children: ReactNode }) {
  return useHasModule(module) ? <>{children}</> : <Navigate to="/" replace />;
}
